import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import 'react-form-builder2/dist/app.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// Initialize cornerstone for DICOM viewing
import './utils/cornerstoneInit';

console.log('Application starting...');

const container = document.getElementById('root');
const root = createRoot(container);

// Add error boundary
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
